<template>
	<ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="reviewers"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :text="field.text" :value="field.value">
	</ies-form-field>
</template>


<script>
    /**
     * Allows the selection of a voucher type ID by choosing its name from
     * a selection downloaded from the API on creation
     */
    export default {
        name: 'ies-hotel-reviewers',
        props: ['field', 'recordData'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                reviewers: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getReviewers();
        },
        methods: {
            getReviewers: function(){
                axios.get('/api/hotel-reviewers/' + this.recordData.hotel_key)
                .then(function(response){
                    console.log(response);
                    var reviewers = [];
					reviewers.push({ text: "Please select a reviewer...", value: null });
                    response.data.forEach(function(reviewer){
                        reviewers.push({ text: reviewer.name, value: reviewer.user_key });
                    });
					reviewers.push({ text: "Other...", value: 0 });
                    this.reviewers = reviewers;
                }.bind(this));
            },
        },
        watch: {
            field: function(newValue){
                console.log("HOTEL REVIEWERS: The field watch fired", newValue);
            },
            viewValue: function (newValue) {
                console.log("HOTEL REVIEWERS: The view value changed");
                this.field.value = newValue;
            }
        }
    }
</script>

